import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import WarrantyMarkdown from "docs/warranty.mdx"

export const getStaticProps = StaticPropsFactory("warranty")

export default function Warranty({ seo }: StaticPropsFactoryProps) {
  return (
    <>
      <SeoMetaData data={seo} />
      <WarrantyMarkdown />
    </>
  )
}
